import axios from "axios";
import store, { persistor } from "./../redux/store";
import { revertUser } from "../redux/slices/userSlice";
import { revertAccount } from "../redux/slices/accountSlice";
// import { logoutUser } from "./../redux/actions/authActions";

export const baseUrl = import.meta.env.PROD
  ? import.meta.env.VITE_API_BASE_URL_PROD
  : import.meta.env.VITE_API_BASE_URL_DEV;

const API = axios.create({
  baseURL: baseUrl,
  timeout: 60000,
});

API.interceptors.request.use(
  (config) => {
    const state = store.getState();
    const accountType = state.account?.accountType || "";

    const issportsbookRoute = config.url.includes("/api/v2/sportsbook")
    if (accountType === "demo" && !issportsbookRoute) {
      return Promise.resolve({ data: null });
    }
    const token = state.user?.token || "";
    const domainId = state.site?.siteDetails?.domainDetails?._id || "";
    const admindomainId = state.site?.siteDetails?.admindomainName?._id || "";
    config.headers.Authorization = `Bearer ${token}`;
    config.headers.Domainid = domainId;
    config.headers.admindomainId = admindomainId;
    config.headers.X_Panel_Type = "user";
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

const handleLogout = () => {
  store.dispatch(revertUser());
  store.dispatch(revertAccount());
  localStorage.clear();
  persistor.purge();
  window.location.href = "/";
};

API.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error(error, "error");
    if (
      error.response &&
      (error.response.status === 403 || error.response.status === 401)
    ) {
      handleLogout();
    }
    return Promise.reject(error);
  }
);

export default API;
